import KlarnaMarketing from 'components/Klarna/KlarnaMarketing/KlarnaMarketing';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showHighlightBNPLBasketSelector } from 'viewModel/selectors/testTarget/showHighlightBNPLBasketSelector';

const fields = createStructuredSelector({
    highlightBNPLBasket: showHighlightBNPLBasketSelector
});

const withHighlightValueVisibilityProps = connect(fields);

export default withHighlightValueVisibilityProps(KlarnaMarketing);
